"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _getResource = require("../../utilities/getResource");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    radioButton: {
      display: 'flex !important',
      alignItems: 'center !important'
    },
    formControlLabel: {
      '& > span': {
        padding: '5px !important'
      }
    }
  };
};
var CustomRadioGroup = /*#__PURE__*/function (_Component) {
  function CustomRadioGroup(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomRadioGroup);
    _this = _callSuper(this, CustomRadioGroup, [props]);
    _this.clearSelection = _this.clearSelection.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(CustomRadioGroup, _Component);
  return (0, _createClass2["default"])(CustomRadioGroup, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.value !== nextProps.value || this.props.children !== nextProps.children) {
        return true;
      }
      return false;
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      this.props.onChange({
        target: {
          value: ''
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        direction = _this$props.direction,
        resources = _this$props.resources,
        language = _this$props.language,
        hideClearButton = _this$props.hideClearButton;
      var props = Object.assign({}, this.props);
      delete props.name;
      props.classes = Object.assign({}, classes);
      delete props.previousValue;
      delete props.classes.radioButton;
      delete props.classes.formControlLabel;
      delete props.validatorListener;
      delete props.questionDescription;
      delete props.hideClearButton;
      delete props.inputRef;
      var previousAnswer = (0, _lodash.find)(this.props.answers, {
        value: this.props.previousValue
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.radioButton
      }, /*#__PURE__*/_react["default"].createElement(_material.RadioGroup, (0, _extends2["default"])({}, props, {
        style: {
          flexDirection: direction.toLowerCase() === 'horizontal' ? 'row' : 'column'
        }
      }), this.props.answers.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
          className: classes.formControlLabel,
          key: item.value,
          control: /*#__PURE__*/_react["default"].createElement(_material.Radio, null),
          value: item.value,
          label: /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              display: 'flex',
              alignItems: 'center'
            }
          }, /*#__PURE__*/_react["default"].createElement(_material.Typography, null, item.label), previousAnswer === item && /*#__PURE__*/_react["default"].createElement(_material.Typography, {
            color: "primary",
            style: {
              marginLeft: 8
            }
          }, (0, _getResource.getResource)(resources, language, 'Label', 'Prior Answer')))
        });
      }), !hideClearButton && /*#__PURE__*/_react["default"].createElement("div", {
        className: "clearSelection",
        onClick: this.clearSelection,
        style: {
          fontSize: '0.75rem',
          marginTop: '5px',
          color: 'rgba(0, 0, 0, 0.54)',
          cursor: 'pointer'
        }
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Clear Selection'))));
    }
  }]);
}(_react.Component);
CustomRadioGroup.propTypes = {
  previousValue: _propTypes["default"].string,
  answers: _propTypes["default"].array
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(CustomRadioGroup);